const general = {
    jpath: ['general'],
    getEmpty() {
        return {
            description: '',
            title: '',
            name: [],
            mf: '',
            molfile: '',
            mw: 0,
            keyword: [],
            meta: {},
            sequence: '',
            kind: '',
        };
    },
};
export default general;
//# sourceMappingURL=general.js.map